import React from 'react';

const InputRows = ({ lang: { lang, title, descMore, description, titleMore } }) => (
    <div className='row'>
        <label htmlFor={lang + 'Title'}>{titleMore}<span>*</span></label>
        <input id={lang + 'Title'} type="text" placeholder={title} required minLength='3' maxLength='50' />
        <label htmlFor={lang + 'Description'}>{descMore}<span>*</span></label>
        <textarea placeholder={description} required id={lang + 'Description'} />
    </div>
);

export default InputRows;
